import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry(() => import("./profile-edit-page"), {
  testId: "rd-profile-edit-loading",
  // «Мой профиль» → «Информация о профиле» (frame 7086-12055).
  shell: {
    breadcrumbRoot: { id: "redesign.profile.title", defaultMessage: "My profile", to: "/pages/my_account" },
    breadcrumbLeaf: { id: "redesign.profile_edit.title", defaultMessage: "Profile information" },
  },
});
